const SCORE_PLACEMENT = 3;
const SCORE_FULL = 10;
const SCORE_EMPTY_GRID = 500;

const GRID_SIZE = 10;
const CELL_SIZE = 30;
const CELL_MARGIN = 2;

module.exports = {
  SCORE_PLACEMENT,
  SCORE_FULL,
  SCORE_EMPTY_GRID,

  GRID_SIZE,
  CELL_SIZE,
  CELL_MARGIN
}
